import axios from "axios";
import {url_local, url_web} from '../url'
//import state from "../../store";
import state from '../../store/index'



export function PDF(form) {
    
    const config = {
        headers : {
            'Content-Type' : 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.post(`${url_local}print-pdf`, form, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al cargar el email y password" + err);
        });
    });
}






  

